<template>
  <v-card>
    <v-dialog
      v-model="showingDialog"
      content-class="dialog-fixed-top"
      :max-width="300"
    >
      <v-card>
        <ODialogBar title="Novo Crachá" @close="dismiss" />
        <v-card-text class="pa-3 children-pa-3">
          <div>
            <v-text-field v-model="newSerial" label="Serial" hide-details />
          </div>
          <div>
            <v-select
              v-model="newType"
              label="Tipo"
              hide-details
              :items="allTypes"
            />
          </div>
        </v-card-text>
        <ODialogButtons class="pa-6" @apply="apply" @cancel="dismiss" />
      </v-card>
    </v-dialog>
    <ORow class="pa-4">
      <span class="headline">Crachás</span>
      <v-spacer />
      <v-btn icon @click="openDialog">
        <v-icon>mdi-plus</v-icon>
      </v-btn>
    </ORow>
    <v-divider />
    <OLoadingLine absolute :value="isLoading" />
    <v-list>
      <v-list-item v-if="row.cards.length < 1">
        <v-list-item-title>(nenhum)</v-list-item-title>
      </v-list-item>
      <v-list-item
        v-for="card in row.cards"
        :key="card.serial"
        class="hoverable"
      >
        <v-list-item-content>
          <v-list-item-title>
            {{ card.serial | formatSerial }}
          </v-list-item-title>
          <v-list-item-subtitle>
            {{ card.type }}
          </v-list-item-subtitle>
        </v-list-item-content>
        <v-list-item-action>
          <v-btn icon @click="confirmDelete(card)">
            <v-icon>mdi-delete</v-icon>
          </v-btn>
        </v-list-item-action>
      </v-list-item>
    </v-list>
  </v-card>
</template>

<script>
import { Technician } from '@/models'

function formatSerial(s) {
  if (s == null) return 'null'
  return s
    .toUpperCase()
    .padStart(16, '0')
    .slice(-10)
}

export default {
  props: {
    row: { required: true }
  },
  data() {
    return {
      isLoading: false,
      showingDialog: false,
      newSerial: null,
      newType: null,
      allTypes: [
        { value: 'main', text: 'Crachá de partida' },
        { value: 'speed-10', text: 'Aferição: 10km/h' },
        { value: 'speed-50', text: 'Aferição: 50km/h' },
        { value: 'distance-100', text: 'Aferição: 100m' },
        { value: 'distance-1000', text: 'Aferição: 1km' },
        { value: 'rpm-1000', text: 'Aferição: 1000 rpm' }
      ]
    }
  },
  methods: {
    dismiss() {
      this.showingDialog = false
    },
    openDialog() {
      this.newSerial = null
      this.newType = null
      this.showingDialog = true
    },
    async apply() {
      let newCards = [...this.row.cards]
      newCards.push({
        serial: formatSerial(this.newSerial),
        type: this.newType
      })
      this.showingDialog = false

      await this.saveAndReload(newCards)
    },
    async confirmDelete(row) {
      let res = await this.$confirmDelete('Deseja remover este crachá?')
      if (res === true) {
        let newCards = this.row.cards.filter(x => {
          return !(x.serial == row.serial && x.type == row.type)
        })

        this.saveAndReload(newCards)
      }
    },

    async saveAndReload(newCards) {
      await this.$loading(() => {
        return Technician.patch(this.row.id, { cards: newCards })
      })
      this.$emit('reload')
    }
  },
  filters: {
    formatSerial
  }
}
</script>

<style></style>
